<!--  Is denk ik niet handig omdat de constructor en ngOnInit enz alsnog wordt uitgevoerd. -->
<!--<div *ecertDisplay="action_identifier">-->
<div>
  <!-- Als !hideLabel dan wordt de action_identifier getoond, anders wordt het label getoond als dat is meegegeven -->
  <label *ngIf="!hideLabel">
    <!-- Vraagteken-icon toevoegen indien er geen label is meegegeven -->
    <div *ecertDisplay="action_identifier; id: id; iconY: '15px'">
      {{ action_identifier | promptvalue | async
      }}<span [class.visible]="verplicht" [class.hidden]="!verplicht" style="color: #ff0000"> *</span>
    </div>
  </label>
  <br *ngIf="!hideLabel" />
  <label *ngIf="hideLabel && label != null">
    {{ label | promptvalue | async }}<span [class.visible]="verplicht" [class.hidden]="!verplicht" style="color: #ff0000">*</span><br
  /></label>
  <mat-form-field class="example-full-width">
    <input
      id="{{ id }}-inputfield"
      type="text"
      #input
      class="input pr-4 text-truncate"
      placeholder="{{ placeholder }}"
      matInput
      [formControl]="formControl"
      [matAutocomplete]="auto"
      (focus)="hasFocus()"
      (blur)="onBlur()"
      (keyup.enter)="onEnter()"
      (change)="inputGewijzigd()"
      [disabled]="_disabled"
    />
    <div class="inputClearButtonWrapper" [class.hidden]="isWaardeLeeg() || _disabled || isDisabled()">
      <button mat-button matSuffix mat-icon-button aria-label="Clear" (click)="inputGewijzigd(undefined, true)" type="button">
        <img src="assets/icons/ui-clear.svg" alt="kruisje" />
      </button>
    </div>
    <mat-autocomplete
      #auto="matAutocomplete"
      (optionSelected)="inputGewijzigd($event.option.value)"
      [displayWith]="getOptieValue.bind(this)"
      [class]="volledigeBreedte ? 'volledigeBreedte' : null"
      [panelWidth]="volledigeBreedte ? 'auto' : null"
    >
      <mat-option
        *ngFor="let optie of gefilterdeOptiesObservable | async"
        class="optie"
        [value]="optie"
        [hidden]="optionHideProperty != null && optie[optionHideProperty]"
        [disabled]="optie.disabled"
        ><!-- door opties extra content mee te geven kan de initiele tekst uitgebreid en apart gestyled worden-->
        <!-- zie bijv USEC-5731-->
        <span *ngIf="optie.extraContent" [class]="optie.extraClass">{{ optie.extraContent }}</span>
<!--         Bij een label met landcode en landnaam worden deze uit elkaar gehaald voor een nette layout-->
        <div *ngIf="optionLabelProperty == 'codeEnNaam'" class="d-flex row">
          <div [class]="getCodeClass(optie)">
            {{ getCode(optie) }}
          </div>
          <div class="col">
            {{ getNaam(optie) }}
          </div>
        </div>
        <div *ngIf="optionLabelProperty != 'codeEnNaam' && optionLabelProperty != 'kvkNummer'">
          {{ optie[this.optionLabelProperty] }}
        </div>

        <div *ngIf="optionLabelProperty == 'kvkNummer'">
          <span class="cursief donkergroengrijs">{{ optie[this.optionLabelProperty] }}</span>
          <div *ngIf="optie.disabled">
            <div class="waarschuwing">
              {{ 'BG_HANDELEN_NAMENS.AL_GEMACHTIGD' | promptvalue | async }}
            </div>
          </div>
          <div style="white-space: pre-wrap">{{ optie[this.optionValueProperty] }}</div>
        </div>
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <!-- Vraagteken-icon toevoegen indien er een label is meegegeven -->
  <div id="{{ id }}-label"></div>
  <div *ecertDisplay="label; id: id + '-label'; iconY: '-61px'"></div>

  <!-- Melding tonen indien geen geldige waarde -->
  <div *ngIf="geenGeldigeWaarde" class="bg-danger px-2 mt-1 pb-2 mb-2 position-relative" id="error_melding">
    <ecert-icon class="ml-1 mr-2 dangericon" [name]="'ui-alert'" [canHover]="false" width="20px"></ecert-icon>
    <br />
    <div class="pt-2">
      <span>{{ geenGeldigeWaardeMelding | promptvalue | async }}</span>
    </div>
  </div>

  <div *ngIf="toonErrors && hasErrors()">
    <ecert-icon [name]="'ui-alert'" class="mr-2" width="20px" [canHover]="false"> </ecert-icon>
    <span class="font-italic"> {{ action_identifier | promptvalue | async }} {{ 'ALGEMEEN.VERPLICHT_VELD' | promptvalue | async }} </span>
  </div>
</div>
